import * as App from '../../app'
import * as Form from '../../components/form'
import * as Modal from '../../components/modal'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

export const deleteCommunityConfirmAction = () => confirm('Are you sure?')

export type UpdateCommunity = (communityIdentifier: App.CommunityIdentifier , payload: any) => Request.RequestAction
export const updateCommunity: UpdateCommunity = (communityIdentifier: App.CommunityIdentifier, payload: any) =>
  Request.requestActionCreator(Constants.UPDATE_COMMUNITY)({
    method: 'PUT',
    payload,
    url: `${Constants.SERVER_RESOURCE}/${communityIdentifier}`,
  })

export type UpdateSearchAction = (searchTerm: string) => any
export const updateSearch: UpdateSearchAction = (searchTerm: string) => ({
  term: searchTerm,
  type: Constants.UPDATE_COMMUNITY_SEARCH_STRING,
})

export type ToggleModal = Modal.Toggle
export const closeModal: ToggleModal = Modal.closeModal(Constants.EXPIRE_COMMUNITY)

export const FormActions = Form.createActionsMap<Types.FormFields>(Constants.EXPIRE_COMMUNITY)
export const FormConstants = Form.createConstantsMap(Constants.EXPIRE_COMMUNITY)

export type EditModalAction = (community: Types.FormFields) => Form.EnterAction<Types.FormFields>
export const onEdit: EditModalAction = (community: Types.FormFields) => FormActions[Form.ENTER](community)



// WEBPACK FOOTER //
// ./src/pages/communities/actions.ts